import Vue       from 'vue'
import Vuex      from 'vuex'
import VueRouter from 'vue-router'

Vue.use(Vuex)
const storeInject = {},storeFiles = require.context('./', true, /\/*.\/store\.js$/)
storeFiles.keys().forEach(key => {
    storeInject[key.replace(/(\.\/|\/store\.js)/g, '')] = storeFiles(key).default
})

export const store =  new Vuex.Store({
	// modules:inject,
    state: {},
    mutations: {},
    actions: {},
    modules: {}
})


Vue.use(VueRouter);
const routerInject = [],routerFiles = require.context('./', true, /\/*.\/router\.js$/)
routerFiles.keys().forEach(key => {
    routerInject.push( routerFiles(key).default );
})

export const router  = new VueRouter({
    routes: [
        ...routerInject,
		{path: '/',meta:{}, name: '首页',component: require('./base/index.vue').default},
		{path: '/404',meta:{}, name: '404',component: require('./base/404.vue').default},
		{path: '/401',meta:{}, name: '401',component: require('./base/401.vue').default},
		{path: '/doc',meta:{}, name: 'doc',component: require('./base/doc.vue').default},
    ],
    scrollBehavior: () => ({y: 0})
})

router.beforeEach((to,from,next)=>{
    if(to.matched.length === 0){
		next('/404');
	}else{
		next();
	}
})


